import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./RenameAccountForm";
import {cancelRenameAccount} from "../../actions/AccountApiActions";
import {Map} from "immutable";
import {validatePresence} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validatePresence(errors, values, "name");

  return errors.toJS();
}


class RenameAccountFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let updatedValues = values.set("accountId", this.props.accountId);
    return this.props.renameAccount(updatedValues.toJS())
      .then((response) => {
        if (response.data.renameAccount.errors.length <= 0) {
          this.props.cancelRenameAccount();
        } else {
          let errors = createValidationErrors(response.data.renameAccount.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRenameAccount();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        validate={validateForm}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const RENAME_ACCOUNT = gql`
  mutation renameAccount($data: NewAccountInput!) {
    renameAccount(input: $data) {
      errors { key message }
    }
  }
`;

const withQueries = compose(
  graphql(RENAME_ACCOUNT, {
    props: ({ mutate }) => ({
      renameAccount: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

const RenameAccountFormContainerWithData = withQueries(RenameAccountFormContainer);

export default connect(null, {cancelRenameAccount})(RenameAccountFormContainerWithData);